import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";
import {
  required
} from "vuelidate/lib/validators";
import store from '@/store';

export default {
  name: "CampusGradeCreate",
  components: {
    MainLayout,
    Select2Multiple
  },

  data() {
    return {
      isLoading: false,
      campusGradeData: {
        acd_year_id: null,
        grade_id: null,
        grading_setting_id: null,
        campus_id: store.state.user.campus_id,
        login_id: store.state.user.id
      },
      periodArr: [],
      gradeArr: [],
      gradingSettingArr: [],
      submitted: false,
      disabled: false,
      campus_name: store.state.user.campus_master.campus_name
    };
  },

  validations: {
    campusGradeData: {
      acd_year_id: {
        required
      },
      grade_id: {
        required
      }
    }
  },

  methods: {
    getAcademicYear() {
      axios.get('period/periodList')
        .then(res => {
          this.periodArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getGrade() {
      axios.get("grade/gradeList")
        .then(res => {
          this.gradeArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getGradingSettings() {
      axios.get("gradingSetting/options", {
        params: {
          campus_id: store.state.user.campus_id,
        },
      })
        .then(res => {
          this.gradingSettingArr = res.data.data || [];
          this.applyDefaultGradingSetting();
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    applyDefaultGradingSetting() {
      if (this.campusGradeData.grading_setting_id != null) {
        return;
      }

      const defaultSetting = this.gradingSettingArr.find(setting => setting.is_default);
      if (defaultSetting) {
        this.campusGradeData.grading_setting_id = defaultSetting.id;
      }
    },

    create() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }

      this.disabled = true;
      const payload = {
        ...this.campusGradeData,
        grading_setting_id: this.campusGradeData.grading_setting_id || null,
      };
      axios.post("campusGrade/create", payload)
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Campus Grade Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'campusGradeList'
            })
          } else {
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }).catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            } else if (error.response.status == 422) {
              const msg = error.response.data.message
                || (error.response.data.errors && Object.values(error.response.data.errors).flat().join('\n'))
                || 'Validation failed.';
              this.$notification.error(msg, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
        });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getGrade();
    this.getAcademicYear();
    this.getGradingSettings();
  },
};
